var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGrayDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.946c-.134 0-.259-.02-.375-.063a.872.872 0 01-.325-.212L.675 2.046a.891.891 0 01-.262-.688A.975.975 0 01.7.671a.948.948 0 01.7-.275c.283 0 .516.092.7.275l3.9 3.9L9.925.646a.894.894 0 01.688-.263.978.978 0 01.687.288.948.948 0 01.275.7.948.948 0 01-.275.7l-4.6 4.6c-.1.1-.209.171-.325.212A1.099 1.099 0 016 6.946z",
    fill: "#A8A9AC"
  })));
}

export default SvgIconGrayDownArrow;